// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/chunks/" + (chunkId === 3722 ? "code-editor" : chunkId) + "-" + {"3722":"817a4bf9730ffbf3acfa","5286":"8c9b1bad00359cb4b660","9765":"c3217278def9256e724d"}[chunkId] + ".css";
};